'use client';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export type ApplicantStatus = 'pending' | 'confirmed' | 'rejected' | 'returned';

interface StatusBadgeProps {
  status: ApplicantStatus;
  size?: 'sm' | 'md';
}

const statusStyles: Record<ApplicantStatus, { className: string; dot: string }> = {
  pending: { className: 'bg-amber-50 text-amber-700 border border-amber-200', dot: 'bg-amber-500' },
  confirmed: { className: 'bg-green-50 text-green-700 border border-green-200', dot: 'bg-green-500' },
  rejected: { className: 'bg-red-50 text-red-700 border border-red-200', dot: 'bg-red-500' },
  returned: { className: 'bg-slate-50 text-slate-600 border border-slate-200', dot: 'bg-slate-400' },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const { t } = useLanguage();
  const cfg = statusStyles[status];
  const label = t.applicantList.status[status];

  return (
    <span data-component-id="src/components/ui/StatusBadge.tsx:25:4" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="25" data-component-end-line="32" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${cfg.className} ${
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
      }`}
    >
      <span data-component-id="src/components/ui/StatusBadge.tsx:30:6" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="30" data-component-end-line="30" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {label}
    </span>
  );
}